import type { Leadership } from "../../types/leadership";

interface LeadershipItemProps {
  item: Leadership;
}

function LeadershipItem({ item }: LeadershipItemProps) {
  return (
    <div className="experience-item">
      <div className="experience-top">
        <div>
          <h3>{item.role}</h3>
          <p className="experience-company">{item.organization}</p>
        </div>
        <span className="experience-meta">
          {item.date ? `${item.date}` : ""}
        </span>
      </div>
      <p className="experience-description">{item.description}</p>
    </div>
  );
}

export default LeadershipItem;
